export default __webpack_public_path__ + "static/char-v-18-21c220d9aeb420de1be07828ad6ca099.png";